import React from "react"

import { adminEntityFieldsMaxWidthSx } from "@/modules/admin/utils/admin-entity-fields-max-width-sx"

import { Box, Skeleton, Stack } from "@mui/material"

interface AdminEntityFieldsSkeletonProps {
  ariaLabel?: string
  fieldCount?: number
  roundedInputs?: boolean
}

export const AdminEntityFieldsSkeleton: React.FC<
  AdminEntityFieldsSkeletonProps
> = ({ ariaLabel, fieldCount = 8, roundedInputs = false }) => (
  <Stack
    aria-busy={ariaLabel ? true : undefined}
    aria-label={ariaLabel}
    sx={{ ...adminEntityFieldsMaxWidthSx, gap: 2 }}
  >
    {Array.from({ length: fieldCount }, (_, index) => (
      <Box key={index}>
        <Skeleton
          height={20}
          sx={{ mb: 0.5 }}
          width={roundedInputs ? "30%" : 120}
        />
        <Skeleton
          height={40}
          variant={roundedInputs ? "rounded" : "text"}
          width="100%"
        />
      </Box>
    ))}
  </Stack>
)
